<template>
  <div class="thread-heading">
    <avatar
      :size="30"
      :user-data="thread.author"
    />
    <div class="item-author">
      {{ $t('comments.published_by') }}<br>
      <span class="author">{{ authorFullName }}</span>
    </div>
    <div class="item-date">
      {{ formattedItemCreationDate }}
    </div>
  </div>
</template>

<script>
import { format } from 'timeago.js'

import Avatar from '../Avatar.vue'

export default {
  name: 'ThreadHeading',
  components: {
    Avatar
  },
  props: {
    thread: {
      type: Object,
      required: true
    }
  },
  computed: {
    authorFullName() {
      return `${this.thread.author.firstName} ${this.thread.author.lastName}`
    },
    formattedItemCreationDate() {
      return format(this.thread.created, this.$i18n.locale)
    }
  }
}
</script>

<style lang="scss" scoped>
.thread-heading {
  display: flex;
  margin-bottom: 15px;
  color: #333;
  text-align: left;

  .avatar {
    margin-right: 10px;
  }

  .item-author {
    font-size: 12px;
    line-height: 15px;

    .author {
      font-weight: 600;
    }
  }

  .item-date {
    flex-grow: 1;
    text-align: right;
    font-size: 12px;

    &:first-letter {
      text-transform: capitalize;
    }
  }
}
</style>
